import { RefObject, useEffect } from "react";

/**
 * Hook that handles clicks outside of the given element
 */
export const useOutsideClick = (
  ref: RefObject<HTMLElement | null>,
  callback: () => void,
  enabled: boolean = true,
) => {
  useEffect(() => {
    if (!enabled) return;

    const handleClick = (event: MouseEvent) => {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        callback();
      }
    };

    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, [ref, callback, enabled]);
};
